import { DashboardLayout } from "@features/home-dashboard/components/DashboardLayout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)")({
  staticData: {
    title: "Accueil",
    section: "Général",
    order: 10,
  },
  component: DashboardLayout,
});
